import React from "react";
import { HiOutlineViewList } from 'react-icons/hi';

import './style.css';


 let DimenProb=(props)=> {





  
  return(
    <div>
        <nav  class="navbar navbar-expand-lg py-3">
  <div class="container">
    <a href="#" class="navbar-brand">
      <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" />
      <span className="text-uppercase font-weight-bold">Company</span>
    </a>

    <button style={{backgroundColor:'#FFCD24',position:'absolute',top:20,right:30}} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span  className="navbar-toggler-icon"></span> <HiOutlineViewList size={30} style={{position:'absolute',top:5,right:13,color:'#666B6E'}} /></button>

    <div id="navbarSupportedContent" className="collapse navbar-collapse">
      <ul className="navbar-nav ml-auto">
        <li className="nav-item active"><a href="#" className="nav-link" style={{color:'#050E2F'}} onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a></li>
        <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F'}}   >Services</a></li>
         <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F'}}      >About </a></li>
        <li className="nav-item"><a href="#" className="nav-link"  style={{color:'#050E2F'}}      >Contact </a></li>
        <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F',width:120}}   >Case Studies</a></li>

        <li className="nav-item"><a href="#" className="nav-link"  style={{color:'#050E2F'}} onClick={()=>props.history.push('/signin')}      >Signin</a></li>

      </ul>
    </div>
  </div>
</nav>
    <div id="centerME">


<div className="boxStAc">
<h4 id="h4">

8-Dimension Problem Defination

</h4>

<br></br>

<h6 id="h62">

Use this canvas to improve your understanding of the problem your initiative is attempting to solve Also use this canvas to create consense amognst the team member on the rationale
</h6>





<h6 id="redh6">
All data is encrypted in the database and in transit. No one else can access your data. Your privacy is guaranteed.
</h6>








<div id="mainDivi">

<textarea name="w3review" rows="5" cols="30" placeholder="Problem" id="textAre">
    
</textarea>


<textarea name="w3review" rows="5" cols="30" placeholder="Situation(s) in which the problem is experienced" id="textAre">
    
</textarea>


<textarea name="w3review" rows="5" cols="30" placeholder="Who in the situation is facing the problem" id="textAre">
    
</textarea>



<textarea name="w3review" rows="5" cols="30" placeholder="Which activity is being done which includes the problem?" id="textAre">
    
</textarea>



<textarea name="w3review" rows="5" cols="30" placeholder="What are the primary root causes of the problem?" id="textAre">
    
</textarea>



<textarea name="w3review" rows="5" cols="30" placeholder="What is the ideal outcome?" id="textAre">
    
</textarea>


<textarea name="w3review" rows="5" cols="30" placeholder="What is the proposed solution?" id="textAre">
    
</textarea>



<textarea name="w3review" rows="5" cols="30" placeholder="How does the proposed solution cause ideal outcome?" id="textAre">
    
</textarea>

<div style={{width:300,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>

<button  onClick={()=>props.history.push('/couActStack')} className="button2" id='BackNext'>Next</button>





</div>

</div>




</div>








</div>
    </div>
  )


}



export default DimenProb;